import { render, staticRenderFns } from "./FieldCard.vue?vue&type=template&id=80ca53ac&"
import script from "./FieldCard.vue?vue&type=script&lang=js&"
export * from "./FieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80ca53ac')) {
      api.createRecord('80ca53ac', component.options)
    } else {
      api.reload('80ca53ac', component.options)
    }
    module.hot.accept("./FieldCard.vue?vue&type=template&id=80ca53ac&", function () {
      api.rerender('80ca53ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FieldCard.vue"
export default component.exports